module.exports = __webpack_public_path__ + "img/raspberry_tart_bite.fa2e0601.jpg";